import React,{useState} from "react";
import { connect } from "react-redux";
import { makeStyles } from 'tss-react/mui';
import { TextField, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import { setError } from "../store/features/error/errorSlice";
import { updateRecordings, updateConference, updateFaxes } from "../utils/utils";
import AdminDialog from "./adminDialog";

const mapDispatchToProps = {
  setError,
};

const useStyles = makeStyles()((theme) => ({
  field: {
    "& .MuiInputBase-input::placeholder": {
      fontSize: "0.85em",
      color: theme.palette.text.disabled,
      opacity: 1,
    },
  },
  textButton: {
    textTransform: "none",
    color: theme.palette.text.secondary,
  },
  primary: {
    textTransform: "none",
    minWidth: 112,
    color: "#fff",
    backgroundColor: theme.palette.primary.light,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      filter: "brightness(0.93)",
      boxShadow: "none",
    },
  },
}));

const EditTitle = (props) => {
    const { classes } = useStyles();
    const {
      open,
      setOpen,
      value,
      setError,
      type,
      defaultValues,
      reloadNotifications,
      setTitleChangeItem,
    } = props;

    const kind = String(type || "").toLowerCase();
    // A conference has a name; a fax and a recording have a title.
    const isConference = kind === "conference";
    const original = value ? String((isConference ? value.name : value.title) || "") : "";

    const [title, setTitle] = useState(original);
    const [saving, setSaving] = useState(false);

    const trimmed = title.trim();
    const canSave = !!value && trimmed !== "" && trimmed !== original.trim() && !saving;

    const handleClose = ()=>{
      setTitleChangeItem(null);
      setOpen(false)
    }

    const handleTitleChange = async () => {
      if (!canSave) return;
      setSaving(true);
      // A copy: defaultValues is shared with the rest of the list.
      let values = { ...defaultValues };
      let res;
      try {
        if(kind==="recording"){
          values.recordings = [{
            rid: value.rid,
            title: trimmed,
            viewed: value.viewed,
            type: value.type
          }];
          res = await updateRecordings(values);
        } else if(isConference) {
          values.conference = {
              name: trimmed,
              type: value.type
            };
          res = await updateConference(values, value.cid);
        } else if(kind==="fax") {
          values.fax = [{
            fid: value.fid,
            title: trimmed,
            viewed: value.viewed,
            group: value.group,
            type: value.type
          }]
          res = await updateFaxes(values);
        }

        if (res instanceof Error) throw res.message;

        setError({
          visible: true,
          type: "success",
          message: `${type} title successfully updated.`,
        });
        reloadNotifications();
        handleClose()
      } catch (error) {
        setSaving(false);
        setError({
          visible: true,
          type: "error",
          message: `Error: ${error}`,
        });
      }
    }

    if (!open) return null;

    return (
      <AdminDialog
        open={open}
        onClose={handleClose}
        icon={<EditIcon />}
        title={isConference ? "Rename conference" : `Edit ${kind} title`}
        subtitle={original.trim() !== "" ? `Currently “${original.trim()}”` : `This ${kind} has no title yet.`}
        footer={
          <>
            <Button onClick={handleClose} className={classes.textButton}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={!canSave}
              className={classes.primary}
              onClick={handleTitleChange}
            >
              {saving ? "Saving…" : "Save"}
            </Button>
          </>
        }
      >
        <TextField
          required
          autoFocus
          id="title-field"
          label={isConference ? "Conference name" : "Title"}
          placeholder={isConference ? "For example, Weekly sales call" : "A short name to find it by"}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleTitleChange(); }}
          onFocus={(e) => e.target.select()}
          variant="outlined"
          size="small"
          fullWidth
          className={classes.field}
          slotProps={{
            inputLabel: { shrink: true },
          }}
        />
      </AdminDialog>
    );
}

export default connect(null, mapDispatchToProps)(EditTitle);
